// extracted by mini-css-extract-plugin
export default {"launcher":"Q_d6","launcher__heading":"Q_d7","launcher__menu-item":"Q_d8"};